module.exports = __webpack_public_path__ + "static/media/router.169c4708.jpeg";